var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-chevron-right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 16,
    height: 16,
    fill: "#0071b9",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M35.9,13.305l-5.364,5.984V16.723l4.056-4.531a.123.123,0,0,0,0-.163L30.536,7.5V4.933L35.9,10.916A1.787,1.787,0,0,1,35.9,13.305Z",
    transform: "translate(-25.447 -4.111)",
    fill: "#0071b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChevronRight);
export default __webpack_public_path__ + "static/media/ico-chevron-right.27eccdf063f813003c7e996b67bd7183.svg";
export { ForwardRef as ReactComponent };